module.exports = __webpack_public_path__ + "img/ico-caret-right-white.e8bccb91.svg";